import React, { useCallback, useEffect, useState } from 'react';
import { Translate, getSortState, translate } from 'react-jhipster';
import { RouteComponentProps } from 'react-router-dom';

import { DeleteRounded } from '@mui/icons-material';
import { Box } from '@mui/material';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { NoData } from 'app/shared/components/no-data/NoData';
import { PageFilters } from 'app/shared/components/page-filters/PageFilters';
import { PageHeader } from 'app/shared/components/page-header/PageHeader';
import { PaginationComponent } from 'app/shared/components/pagination/Pagination';
import { TableComponent } from 'app/shared/components/table-component/TableComponent';
import { IHeaderItem } from 'app/shared/interfaces/headerItemsInterface';
import { IListData } from 'app/shared/interfaces/listDataInterface';
import { ISearchTypes } from 'app/shared/interfaces/searchTypesInterface';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { Loading } from 'app/shared/util/loading';
import { ASC, DEFAULT_ITEMS_PER_PAGE, DESC } from 'app/shared/util/pagination.constants';
import { getEntities } from './inspection-item.reducer';

const groupButtonIcons = [
  {
    icon: <DeleteRounded color="error" />,
    path: 'delete',
  },
];

const headers: IHeaderItem[] = [
  { key: 'name', sortable: true, component: <Translate contentKey="fleetSenseApp.inspectionItem.name" /> },
  { key: 'description', sortable: true, component: <Translate contentKey="fleetSenseApp.inspectionItem.description" /> },
];

const data: IListData[] = [
  { type: 'text', value: 'name' },
  { type: 'text', value: 'description' },
  { type: 'groupButtonIcons', value: 'id' },
];

export const InspectionItem = (props: RouteComponentProps<{ url: string }>) => {
  const dispatch = useAppDispatch();

  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getSortState(props.location, DEFAULT_ITEMS_PER_PAGE, 'name'), props.location.search)
  );

  const inspectionItemList = useAppSelector(state => state.inspectionItem.entities);
  const loading = useAppSelector(state => state.inspectionItem.loading);
  const totalItems = useAppSelector(state => state.inspectionItem.totalItems);
  const [nameSearch, setNameSearch] = useState('');

  const searchTypes: ISearchTypes[] = [
    {
      label: translate('fleetSenseApp.inspectionItem.searchLabel'),
      placeholder: translate('fleetSenseApp.inspectionItem.searchPlaceholder'),
      value: nameSearch,
      setValue: setNameSearch,
    },
  ];

  const getAllEntities = useCallback(() => {
    dispatch(
      getEntities({
        page: paginationState.activePage - 1,
        size: paginationState.itemsPerPage,
        sort: `${paginationState.sort},${paginationState.order}`,
        nameSearch,
      })
    );
  }, [paginationState]);

  const sortEntities = () => {
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (props.location.search !== endURL) {
      props.history.replace(`${props.location.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = (_, currentPage) =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const setActivePage = () => {
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
  };

  useEffect(() => {
    getAllEntities();
  }, [getAllEntities]);

  const { match } = props;

  return (
    <Box sx={{ backgroundColor: 'primary.main', borderRadius: '8px', paddingTop: '16px', textAlign: 'center', padding: '24px' }}>
      <PageHeader
        headingId="fleetSenseApp.inspectionItem.home.title"
        headingDataCy="InspectionItemHeading"
        contentKey="fleetSenseApp.inspectionItem.home.title"
        buttonTextKey="fleetSenseApp.inspectionItem.home.createLabel"
        match={match}
      />
      <PageFilters setActivePage={setActivePage} searchTypes={searchTypes} showFilters={['filters']} />
      {!loading && !!inspectionItemList.length && (
        <TableComponent
          listData={data}
          headers={headers}
          list={inspectionItemList}
          match={match}
          sortFunction={sort}
          pagination={paginationState}
          groupButtonIcons={groupButtonIcons}
        />
      )}
      {!loading && !inspectionItemList.length && <NoData title="inspection item" />}
      {loading && <Loading />}
      <PaginationComponent paginationState={paginationState} totalItems={totalItems} onChange={handlePagination} list={inspectionItemList} />
    </Box>
  );
};

export default InspectionItem;
